<template>
  <v-container
    fluid
    style="padding:0px;height: 50px;"
  >
    <v-row>
      <!-- hide details switch START -->
      <v-col
        lg="2"
        md="3"
        sm="3"
        cols="5"
      >
        <v-switch
          v-model="hideDetails"
          label="Hide details"
        />
      </v-col>
      <!-- hide details switch END -->

      <!-- search dataset START -->
      <v-col>
        <v-text-field
          v-model="searchText"
          append-icon="search"
          :label="type + ' name'"
        />
      </v-col>
      <!-- search dataset END -->
    </v-row>
  </v-container>
</template>
<script>
  export default {
    props: {
      defaultHidden: Boolean,
      type: {},
    },
    data () {
      return {
        hideDetails: '',
        searchText: '',
      }
    },
    watch: {
      hideDetails: function () {
        this.$emit('hide', this.hideDetails)
      },
      searchText: function () {
        this.$emit('typing', this.searchText)
      },
    },
    mounted: function () {
      this.hideDetails = this.defaultHidden
    },
    methods: {
    },
  }
</script>
